import { CityAndStateRV } from '@/lib/support/components/PostalCodeLookupObserver/types'

/***
 * default adapter gives us a reference
 *
 */
export function noOpAdapter(): CityAndStateRV | null {
  return null
}
